var _rect, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _g, _rect2, _path7, _path8, _path9, _path0, _ellipse2, _path1, _path10, _g2, _rect3, _path11, _path12, _path13, _path14, _ellipse3, _path15, _path16, _g3, _rect4, _path17, _rect5, _path18, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceSwimming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 145,
    viewBox: "0 0 273 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#60A3FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0459 74.6301L17.9326 74.2931C19.192 74.0682 20.4813 74.0682 21.7407 74.2931L25.5142 74.967C26.7736 75.1919 28.0628 75.1919 29.3223 74.967L33.0957 74.2931C34.3551 74.0682 35.6444 74.0682 36.9038 74.2931L40.6772 74.967C41.9366 75.1919 43.2259 75.1919 44.4853 74.967L48.2588 74.2931C49.5182 74.0682 50.8075 74.0682 52.0669 74.2931L53.9536 74.6301",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3848 81.4611L19.7356 81.2109C21.0394 80.9695 22.3763 80.9695 23.68 81.2109L26.3818 81.7113C27.6855 81.9527 29.0225 81.9527 30.3262 81.7113L33.0279 81.2109C34.3317 80.9695 35.6686 80.9695 36.9724 81.2109L39.6741 81.7113C40.9778 81.9527 42.3148 81.9527 43.6185 81.7113L46.3203 81.2109C47.624 80.9695 48.9609 80.9695 50.2647 81.2109L51.6155 81.4611",
    stroke: "white",
    strokeWidth: 2.70772,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3848 81.4611L19.7356 81.2109C21.0394 80.9695 22.3763 80.9695 23.68 81.2109L26.3818 81.7113C27.6855 81.9527 29.0225 81.9527 30.3262 81.7113L33.0279 81.2109C34.3317 80.9695 35.6686 80.9695 36.9724 81.2109L39.6741 81.7113C40.9778 81.9527 42.3148 81.9527 43.6185 81.7113L46.3203 81.2109C47.624 80.9695 48.9609 80.9695 50.2647 81.2109L51.6155 81.4611",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4619 88.2306L21.7692 88.1608C23.3493 87.8017 24.9899 87.8017 26.57 88.1608L27.1846 88.3005C28.7647 88.6596 30.4053 88.6596 31.9854 88.3005L32.6 88.1608C34.1801 87.8017 35.8206 87.8017 37.4007 88.1608L38.0154 88.3005C39.5955 88.6596 41.236 88.6596 42.8161 88.3005L43.4308 88.1608C45.0109 87.8017 46.6514 87.8017 48.2315 88.1608L48.5388 88.2306",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.9088,
    cy: 65.4304,
    rx: 4.4,
    ry: 4.40015,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5388 55.6152L40.6599 57.9426C38.8904 59.0044 37.8781 60.9795 38.0494 63.036L38.4465 67.8003",
    stroke: "white",
    strokeWidth: 4.06161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11304_9722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 59,
    width: 38,
    height: 13
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9336 70.2337L16.0469 70.5706V59.0625H53.9546V70.5706L52.0678 70.2337C50.8084 70.0088 49.5192 70.0088 48.2598 70.2337L44.4863 70.9075C43.2269 71.1324 41.9376 71.1324 40.6782 70.9075L36.9048 70.2337C35.6454 70.0088 34.3561 70.0088 33.0967 70.2337L29.3232 70.9075C28.0638 71.1324 26.7745 71.1324 25.5151 70.9075L21.7417 70.2337C20.4823 70.0088 19.193 70.0088 17.9336 70.2337Z",
    fill: "#24284E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11304_9722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67773 79.3104L38.9075 62.8886C39.3633 62.6325 39.9387 62.8692 40.0823 63.3719C41.9154 69.7881 44.6831 75.8995 48.2962 81.5096L49.2777 83.0336L9.67773 79.3104Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#60A3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.046 74.6301L113.933 74.2931C115.192 74.0682 116.481 74.0682 117.741 74.2931L121.514 74.967C122.774 75.1919 124.063 75.1919 125.322 74.967L129.096 74.2931C130.355 74.0682 131.644 74.0682 132.904 74.2931L136.677 74.967C137.937 75.1919 139.226 75.1919 140.485 74.967L144.259 74.2931C145.518 74.0682 146.807 74.0682 148.067 74.2931L149.954 74.6301",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.385 81.4611L115.736 81.2109C117.039 80.9695 118.376 80.9695 119.68 81.2109L122.382 81.7113C123.686 81.9527 125.022 81.9527 126.326 81.7113L129.028 81.2109C130.332 80.9695 131.669 80.9695 132.972 81.2109L135.674 81.7113C136.978 81.9527 138.315 81.9527 139.619 81.7113L142.32 81.2109C143.624 80.9695 144.961 80.9695 146.265 81.2109L147.616 81.4611",
    stroke: "white",
    strokeWidth: 2.70772,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.385 81.4611L115.736 81.2109C117.039 80.9695 118.376 80.9695 119.68 81.2109L122.382 81.7113C123.686 81.9527 125.022 81.9527 126.326 81.7113L129.028 81.2109C130.332 80.9695 131.669 80.9695 132.972 81.2109L135.674 81.7113C136.978 81.9527 138.315 81.9527 139.619 81.7113L142.32 81.2109C143.624 80.9695 144.961 80.9695 146.265 81.2109L147.616 81.4611",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M117.462 88.2306L117.769 88.1608C119.349 87.8017 120.99 87.8017 122.57 88.1608L123.185 88.3005C124.765 88.6596 126.405 88.6596 127.985 88.3005L128.6 88.1608C130.18 87.8017 131.821 87.8017 133.401 88.1608L134.015 88.3005C135.595 88.6596 137.236 88.6596 138.816 88.3005L139.431 88.1608C141.011 87.8017 142.651 87.8017 144.232 88.1608L144.539 88.2306",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.909,
    cy: 65.4304,
    rx: 4.4,
    ry: 4.40015,
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M140.539 55.6152L136.66 57.9426C134.89 59.0044 133.878 60.9795 134.049 63.036L134.446 67.8003",
    stroke: "white",
    strokeWidth: 4.06161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11304_9722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 59,
    width: 38,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.934 70.2337L112.047 70.5706V59.0625H149.955V70.5706L148.068 70.2337C146.808 70.0088 145.519 70.0088 144.26 70.2337L140.486 70.9075C139.227 71.1324 137.938 71.1324 136.678 70.9075L132.905 70.2337C131.645 70.0088 130.356 70.0088 129.097 70.2337L125.323 70.9075C124.064 71.1324 122.775 71.1324 121.515 70.9075L117.742 70.2337C116.482 70.0088 115.193 70.0088 113.934 70.2337Z",
    fill: "#24284E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11304_9722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.678 79.3104L134.908 62.8886C135.363 62.6325 135.939 62.8692 136.082 63.3719C137.915 69.7881 140.683 75.8995 144.296 81.5096L145.278 83.0336L105.678 79.3104Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 31,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#60A3FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.308 75.5376L205.666 75.1164C207.24 74.8353 208.852 74.8353 210.426 75.1164L215.143 75.9587C216.717 76.2399 218.329 76.2399 219.903 75.9587L224.62 75.1164C226.194 74.8353 227.806 74.8353 229.38 75.1164L234.097 75.9587C235.671 76.2399 237.283 76.2399 238.857 75.9587L243.574 75.1164C245.148 74.8353 246.76 74.8353 248.334 75.1164L250.692 75.5376",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.23 84.0768L207.919 83.7641C209.549 83.4624 211.22 83.4624 212.85 83.7641L216.227 84.3896C217.856 84.6913 219.528 84.6913 221.157 84.3896L224.534 83.7641C226.164 83.4624 227.835 83.4624 229.465 83.7641L232.842 84.3896C234.472 84.6913 236.143 84.6913 237.773 84.3896L241.15 83.7641C242.779 83.4624 244.451 83.4624 246.08 83.7641L247.769 84.0768",
    stroke: "white",
    strokeWidth: 3.38465,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.23 84.0768L207.919 83.7641C209.549 83.4624 211.22 83.4624 212.85 83.7641L216.227 84.3896C217.856 84.6913 219.528 84.6913 221.157 84.3896L224.534 83.7641C226.164 83.4624 227.835 83.4624 229.465 83.7641L232.842 84.3896C234.472 84.6913 236.143 84.6913 237.773 84.3896L241.15 83.7641C242.779 83.4624 244.451 83.4624 246.08 83.7641L247.769 84.0768",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M210.077 92.5388L210.461 92.4515C212.436 92.0026 214.487 92.0026 216.462 92.4515L217.231 92.6261C219.206 93.075 221.256 93.075 223.231 92.6261L224 92.4515C225.975 92.0026 228.026 92.0026 230.001 92.4515L230.769 92.6261C232.744 93.075 234.795 93.075 236.77 92.6261L237.538 92.4515C239.513 92.0026 241.564 92.0026 243.539 92.4515L243.923 92.5388",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.886,
    cy: 64.0373,
    rx: 5.5,
    ry: 5.50019,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.923 51.7695L234.075 54.6788C231.863 56.006 230.598 58.4749 230.812 61.0455L231.308 67.0008",
    stroke: "white",
    strokeWidth: 5.07701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11304_9722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 56,
    width: 48,
    height: 16
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.666 70.0411L203.308 70.4623V56.0771H250.692V70.4623L248.334 70.0411C246.76 69.76 245.148 69.76 243.574 70.0411L238.857 70.8834C237.283 71.1645 235.671 71.1645 234.097 70.8834L229.38 70.0411C227.806 69.76 226.194 69.76 224.62 70.0411L219.903 70.8834C218.329 71.1645 216.717 71.1645 215.143 70.8834L210.426 70.0411C208.852 69.76 207.24 69.76 205.666 70.0411Z",
    fill: "#24284E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11304_9722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.346 81.387L231.883 60.8598C232.453 60.5397 233.172 60.8356 233.351 61.4639C235.643 69.4842 239.102 77.1234 243.619 84.136L244.846 86.041L195.346 81.387Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 101L159.5 105L166.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 101L63.5 105L70.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 143,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 21,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 134.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 121.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 12L193.5 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 7L250 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233 129L236.5 143",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceSwimming);
export default __webpack_public_path__ + "static/media/persistence-swimming.cacc53160c536522baf684ec7c4231c6.svg";
export { ForwardRef as ReactComponent };